import { SuggestedQuestion } from './actions';

export const DEFAULT_SUGGESTED_QUESTIONS: SuggestedQuestion[] = [
    {
        id: '1',
        text: 'Generate One Pager',
        flowKey: 'one_pager',
    },
    {
        id: '4',
        text: 'Generate One Pager as docx',
        hint: '(takes ~7-8 mins)',
        flowKey: 'one_pager_docx',
    },
    {
        id: '2',
        text: 'What are the top 3 competitors?',
    },
    {
        id: '3',
        display: 'What debt works for this company?',
        text: 'Give me the debt recommendations for this company and be very thorough with using all the relevant data as needed?',
    },
];

export enum MessageType {
    USER = 'user',
    ASSISTANT = 'assistant',
}

export const COPY_TARGET = {
    FULL_CHAT: 'fullChat',
} as const;

const namespace = 'ASK_AICA_';

export const ASK_AICA_CONSTANTS = {
    // Chat functionality constants
    INITIALISE_MESSAGE_THREAD: `${namespace}INITIALISE_MESSAGE_THREAD`,
    ADD_MESSAGE: `${namespace}ADD_MESSAGE`,
    UPDATE_MESSAGE: `${namespace}UPDATE_MESSAGE`,
    CLEAR_MESSAGES: `${namespace}CLEAR_MESSAGES`,
    SET_IS_LOADING: `${namespace}SET_IS_LOADING`,
    SET_IS_LOADING_CHAT_HISTORY: `${namespace}SET_IS_LOADING_CHAT_HISTORY`,
    SET_IS_CLEARING_CHAT: `${namespace}SET_IS_CLEARING_CHAT`,
    SET_ERROR: `${namespace}SET_ERROR`,
    SET_REASONING: `${namespace}SET_REASONING`,
    RESET_REASONING: `${namespace}RESET_REASONING`,
    UPDATE_REASONING: `${namespace}UPDATE_REASONING`,

    // UI-related constants
    SET_ASK_AICA_OPEN: `${namespace}SET_ASK_AICA_OPEN`,
    SET_ASK_AICA_SELECTED_SOURCES: `${namespace}SET_ASK_AICA_SELECTED_SOURCES`,
    SET_ASK_AICA_RIGHT_PANEL_MODE: `${namespace}SET_ASK_AICA_RIGHT_PANEL_MODE`,

    // Global suggested questions constants
    SET_GLOBAL_SUGGESTED_QUESTIONS: `${namespace}SET_GLOBAL_SUGGESTED_QUESTIONS`,
    UPDATE_GLOBAL_SUGGESTED_QUESTIONS: `${namespace}UPDATE_GLOBAL_SUGGESTED_QUESTIONS`,
};
